import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumTonnes, renderGridSummarySumHL } from 'components/global/utils';
import { SkuDcReportGridData } from '@pages/reporting-pages/deliveries-sku-dc/types/SkuDcReportGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<SkuDcReportGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'total_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'total_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'total_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'on_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'on_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'on_ordersCount')}</p>
			</div>


			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'off_volume')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumTonnes(data, 'off_weight')}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'off_ordersCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;